import { render, staticRenderFns } from "./trend-tag.vue?vue&type=template&id=0b2e6b34"
import script from "./trend-tag.vue?vue&type=script&lang=js"
export * from "./trend-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports